import ForumIcon from '@material-ui/icons/Forum';
import IssueList from './IssueList';
import IssueCreate from './IssueCreate';

export default {
    list: IssueList,
    create: IssueCreate,
    icon: ForumIcon,
};
